import { AppConfigContext } from '@App/AppConfigContext';
import {
  deleteBranchPreviewName,
  deleteBranchPreviewUrl,
  setBranchPreviewName,
  setBranchPreviewUrl
} from '@Framework/branchPreview';
import { CURRENT_SCRIPT_BRANCH } from '@Framework/constants';
import {
  Box,
  createStyles,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  makeStyles,
  Typography
} from '@material-ui/core';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';
import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Button } from '../../atoms/Button/Button';

const BranchPreview = (): React.ReactElement => {
  const { branchPreviewUrl, branchPreviewName } = useContext(AppConfigContext);
  const [currentUrl, setCurrentUrl] = useState<string>(branchPreviewUrl || '');
  const [branchName, setBranchName] = useState<string>(branchPreviewName || '');

  const useStyles = makeStyles(() =>
    createStyles({
      root: {},
      content: {
        maxWidth: '72em',
        marginRight: 'auto',
        marginLeft: 'auto',
        paddingRight: '1rem',
        paddingLeft: '1rem'
      },
      input: {
        minHeight: '1.75rem'
      }
    })
  );

  const classes = useStyles();

  const currentBranch = CURRENT_SCRIPT_BRANCH;
  const queryParam = useLocation().search;

  return (
    <>
      <Box bgcolor={CORPORATE_COLORS.LIGHT_GRAY}>
        <Box display="flex" p={2.5} pt={3.7} component="div" flex="1" className={classes.content}>
          <Box flex={1}>
            <Typography variant="h2">Branch Preview</Typography>

            {queryParam === '?invalidBranch=true' && (
              <Typography variant="h3" style={{ color: 'red' }}>
                Feature branch or branch preview could not be found. <br />
                Make sure that the branch is deployed and try again.
              </Typography>
            )}
            <Typography variant="h3">Current branch: {currentBranch}</Typography>
          </Box>
        </Box>
      </Box>

      <Box display="flex" p={2.5} component="div" flex="1" className={classes.content}>
        <FormControl fullWidth>
          <InputLabel htmlFor="branch">Branch Name</InputLabel>
          <Input
            id="branch"
            className={classes.input}
            fullWidth
            value={branchName}
            onChange={e => {
              setBranchName(e.target.value);
            }}
            aria-describedby="branch-text"
          />
          <FormHelperText id="branch-text">Set ods-client branch name e.g. wsssh-113</FormHelperText>
        </FormControl>
      </Box>

      <Box display="flex" p={2.5} component="div" flex="1" className={classes.content}>
        <FormControl fullWidth>
          <InputLabel htmlFor="full-uri">Full URL</InputLabel>
          <Input
            className={classes.input}
            id="full-uri"
            fullWidth
            value={currentUrl}
            onChange={e => {
              setCurrentUrl(e.target.value);
            }}
            aria-describedby="full-uri-text"
          />
          <FormHelperText id="full-uri-text">
            Set only if you want to change to <strong>full</strong> url
          </FormHelperText>
        </FormControl>
      </Box>

      <Box display="flex" p={2.5} component="div" flex="1" className={classes.content}>
        <Box>
          <Button
            variant={'contained'}
            color={'primary'}
            onClick={e => {
              e.preventDefault();

              if (branchName !== undefined && branchName.length > 0) {
                setBranchPreviewName(branchName);
                deleteBranchPreviewUrl();
              } else {
                if (currentUrl !== undefined && currentUrl.length > 0) {
                  setBranchPreviewUrl(currentUrl);
                  deleteBranchPreviewName();
                } else {
                  deleteBranchPreviewName();
                  deleteBranchPreviewUrl();
                }
              }

              setTimeout(() => {
                location.href = location.href.replace('?invalidBranch=true', '');
              }, 250);
            }}
          >
            Set preview
          </Button>
        </Box>

        <Box ml={5}>
          <Button
            variant={'contained'}
            color={'secondary'}
            onClick={e => {
              e.preventDefault();

              deleteBranchPreviewUrl();
              deleteBranchPreviewName();

              setTimeout(() => {
                location.reload();
              }, 250);
            }}
          >
            Clear
          </Button>
        </Box>
      </Box>
    </>
  );
};

export { BranchPreview };
